import EditProfile from '../components/EditProfile';
import PageLayout from '../components/pageLayout';

function EditProfilePage() {
    return (
        <PageLayout children={<EditProfile />} />
    );
}

export default EditProfilePage;
